import { Grid, Typography } from "@mui/material";
import ThreadsManagement from "./ThreadsManagement";


const ContentManagementUI: React.FC = () => {
  return <Grid container>
        <Grid item xs={12}>
          {/* <div style={{ display: "flex", flexDirection: "row" }}> */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              paddingRight: "10px",
              justifyContent: "space-between",
              background: "var(--header)",
              color: "#fff",
              height: "6vh",
              paddingTop: "20px",
            }}
          >
            <Typography
              style={{
                textTransform: "uppercase",
                color: "#fff",
                paddingLeft: "1rem",
              }}
              fontWeight={"bold"}
              variant={"h6"}
            >
              &nbsp;Product Management
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "stretch",
              }}
            >


            </div>
          </div>
        </Grid>
        <Grid container>
            <Grid
          item
          xs={12}
          sx={{
            padding: "1.5rem",
          }}
        >
            <ThreadsManagement />
        </Grid>
        <Grid item xs={12}>
          {/* Additional content can go here */}
        </Grid>
        <Grid item xs={12}>
          {/* Additional content can go here */}
        </Grid>
        </Grid>
      </Grid>
}

export default ContentManagementUI;